export default __webpack_public_path__ + "static/Economic Model Whitepaper - Polish-2272a28722ee4f70341e98328b532bfe.pdf";